export default {
  projectDesc: 'A simple and powerful dialog, dialog type including <strong>Modal</strong>, <strong>Alert</strong>, <strong>Mask</strong> and <strong>Toast</strong>, based on <strong>Vue2</strong>.',
  iconTitle: 'The Dialog Icon',
  alertIcon: 'The icons in alert dialog used are made by',
  toastIcon: 'and control icon, toast icon used are come from',
  demo: {
    instanceName: 'specify the plugin instance name, used <code>$dlg</code> by default and it can only config in plugin install',
    modalTitle: 'open a component(page) in Modal dialog',
    alertTitle: 'open a message alert dialog, including info, warning, error, success, confirm types',
    maskTitle: 'open a full screen mask',
    toastTitle: 'open a corner dialog, have 4 message type and 6 corner position',
    vuexInModal: 'Use <strong>Vuex</strong> in the inner component of Modal',
    helper: {
      title: 'Dialog helper collection',
      close: 'Close a dialog by key, when no specified key parameter, will close the last one opened dialog',
      closeAll: 'Close all dialogs at once'
    }
  },
  option: {
    message: 'The message show in dialog, support html tags',
    messageType: 'dialog message type',
    title: 'dialog title bar text or title bar show control, set false to close title bar',
    width: 'dialog width',
    height: 'dialog height',
    params: 'send parameters to component and use <code>props:{ xxx: Type }</code> to receive this params in component',
    closeButton: 'the close dialog button show or not',
    maxButton: 'click to make dialog maximize, and click again to restore',
    position: 'corner position type for dialog',
    singletonKey: 'specified a key to make dialog singleton(the same key dialog will not open in the same time)',
    language: 'dialog use language',
    icon: 'display message type icon',
    customClass: 'custom theme class name',
    shaking: 'whether to display a shaking animation when clicking outside of dialog',
    closeTime: 'auto close dialog time(seconds), set false to disable auto close\t',
    cancelCallback: 'close dialog callback, trigger by some case: \n' +
          'click the close button in top right corner(Model,Toast mode)\n' +
          'click \'cancel\' button in Alert mode (<kbd>confirm</kbd> message type)',
    fullscreen: 'open and maximize modal dialog'
  },
  api: {
    close: 'close dialog, require to specify dialog key',
    closeAll: 'close all dialogs'
  }
}
